import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5df80f67"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "content" };
const _hoisted_2 = { class: "main_title" };
const _hoisted_3 = { class: "sub_title" };
const _hoisted_4 = { class: "main_box" };
const _hoisted_5 = { class: "titles" };
const _hoisted_6 = { class: "value" };
const _hoisted_7 = { class: "flex contents" };
const _hoisted_8 = { class: "titles" };
const _hoisted_9 = { class: "value" };
const _hoisted_10 = { class: "flex contents" };
const _hoisted_11 = { class: "titles" };
const _hoisted_12 = { class: "value" };
const _hoisted_13 = {
    key: 0,
    class: "flex contents"
};
const _hoisted_14 = { class: "titles" };
const _hoisted_15 = { class: "value" };
const _hoisted_16 = {
    key: 1,
    class: "flex contents"
};
const _hoisted_17 = { class: "titles" };
const _hoisted_18 = { class: "value" };
const _hoisted_19 = {
    key: 2,
    class: "flex contents"
};
const _hoisted_20 = { class: "titles" };
const _hoisted_21 = { class: "value" };
const _hoisted_22 = { class: "flex contents" };
const _hoisted_23 = { class: "titles" };
const _hoisted_24 = { class: "value" };
const _hoisted_25 = { class: "flex contents" };
const _hoisted_26 = { class: "titles" };
const _hoisted_27 = { class: "value" };
const _hoisted_28 = { class: "flex buttons" };
import { useStore } from '@/store/store';
import { useMessage } from '@/const/messages';
import { decimalize, decimalizeByExchange } from '@/logics/utils';
import { ref, watch } from 'vue';
import MaterialIcon from '@/materials/atoms/MaterialIcon.vue';
import CheckBox from '@/materials/atoms/CheckBox.vue';
import { useSound } from '@/logics/sound';
export default /*#__PURE__*/ _defineComponent({
    props: {
        base: null,
        quote: null,
        orderType: null,
        tradeType: null,
        price: null,
        amount: null,
        marketMode: null
    },
    emits: ["order", "cancel"],
    setup(__props, { emit }) {
        const props = __props;
        const store = useStore();
        const { format, ORDER_CONFIRM_TITLES } = useMessage();
        const { closeClear, play } = useSound();
        const onOrder = () => {
            emit('order', check.value);
        };
        const onClose = () => {
            play(closeClear);
            emit('cancel');
        };
        const setAvailableBalance = () => {
            const symbol = props.orderType === 'Buy' ? props.quote : props.base;
            const balanceInfo = store.state.balances.find((b) => b.symbol === symbol);
            const onHold = Number(balanceInfo === null || balanceInfo === void 0 ? void 0 : balanceInfo.onHold);
            const balance = Number(balanceInfo === null || balanceInfo === void 0 ? void 0 : balanceInfo.balance);
            return `${decimalize(balance - onHold, symbol, store.state.currencyInfo)} ${symbol}`;
        };
        const getExceptedPrice = () => {
            const targetPrice = props.tradeType === 'Limit' ? props.price : store.state.latestValue;
            return decimalizeByExchange(Number(targetPrice) * Number(props.amount), store.getters.symbol.pair, store.state.currencyPairInfo);
        };
        const check = ref(false);
        const onChangeCheck = (isChecked) => {
            check.value = isChecked;
        };
        const latestValue = ref(store.state.latestValue);
        const expectedTotal = ref(getExceptedPrice());
        watch(() => store.state.latestValue, () => {
            latestValue.value = store.state.latestValue;
            if (props.tradeType === 'Market') {
                expectedTotal.value = getExceptedPrice();
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: "overlay overlay_z",
                    onClick: onClose
                }),
                _createElementVNode("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("label", null, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).TITLE)), 1),
                        _createVNode(MaterialIcon, {
                            name: "close",
                            class: "close_button",
                            onClick: onClose
                        })
                    ]),
                    _createElementVNode("div", _hoisted_3, [
                        _createVNode(CheckBox, {
                            mode: "dark",
                            label: _unref(format)(_unref(ORDER_CONFIRM_TITLES).LEAVE_OUT_CHECK),
                            id: "order",
                            isInitCheck: false,
                            onChange: onChangeCheck
                        }, null, 8, ["label"])
                    ]),
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["flex contents", props.orderType])
                        }, [
                            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).ORDER)), 1),
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("label", null, _toDisplayString(props.orderType), 1)
                            ])
                        ], 2),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).PAIR)), 1),
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("label", null, _toDisplayString(props.base) + " / " + _toDisplayString(props.quote), 1)
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).LIMIT_OR_MARKET)), 1),
                            _createElementVNode("div", _hoisted_12, [
                                _createElementVNode("label", null, _toDisplayString(props.tradeType), 1)
                            ])
                        ]),
                        (props.tradeType === 'Limit' || (props.tradeType === 'Market' && props.marketMode === 'Price'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).PRICE)), 1),
                                _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(decimalize)(Number(props.price), props.quote, _unref(store).state.currencyInfo)) + " " + _toDisplayString(props.quote), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (props.tradeType === 'Limit' || (props.tradeType === 'Market' && props.marketMode === 'Amount'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).AMOUNT)), 1),
                                _createElementVNode("div", _hoisted_18, _toDisplayString(_unref(decimalize)(Number(props.amount), props.base, _unref(store).state.currencyInfo)) + " " + _toDisplayString(props.base), 1)
                            ]))
                            : _createCommentVNode("", true),
                        (props.tradeType === 'Limit' || (props.tradeType === 'Market' && props.marketMode === 'Amount'))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).EXPECTED_TOTAL)), 1),
                                _createElementVNode("div", _hoisted_21, _toDisplayString(expectedTotal.value) + " " + _toDisplayString(props.quote), 1)
                            ]))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_22, [
                            _createElementVNode("div", _hoisted_23, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).AVAILABLE_BALANCE)), 1),
                            _createElementVNode("div", _hoisted_24, _toDisplayString(setAvailableBalance()), 1)
                        ]),
                        _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).MARKET_PRICE)), 1),
                            _createElementVNode("div", _hoisted_27, _toDisplayString(_unref(decimalize)(_unref(store).state.latestValue, props.quote, _unref(store).state.currencyInfo)) + " " + _toDisplayString(props.quote), 1)
                        ])
                    ]),
                    _createElementVNode("div", _hoisted_28, [
                        _createElementVNode("div", {
                            onClick: onClose,
                            class: "cancel"
                        }, _toDisplayString(_unref(format)(_unref(ORDER_CONFIRM_TITLES).CLOSE)), 1),
                        _createElementVNode("div", {
                            onClick: onOrder,
                            class: "order"
                        }, _toDisplayString(`${props.orderType} / ${props.base}`), 1)
                    ])
                ])
            ], 64));
        };
    }
});
